import { useMemo } from "react";
import { Select } from "antd";
import { LogsFilterProps } from "../types";
import "./LogsFilter.css";

/**
 * Reusable filter dropdown for logs
 * Supports predefined options and custom value entry
 */
export function LogsFilter({ label, value, options, onChange, placeholder }: LogsFilterProps) {
  // Check if current value is in options
  const isCustomValue = useMemo(() => {
    if (!value) return false;
    return !options.some((opt) => opt.value === value);
  }, [value, options]);

  // Build select options
  const selectOptions = useMemo(() => {
    const opts = options.map((opt) => ({
      value: opt.value,
      label: opt.label,
      disabled: opt.disabled,
    }));

    return opts;
  }, [options]);

  return (
    <div className="logs-filter">
      <label className="logs-filter-label">{label}</label>
      <Select
        value={isCustomValue ? value : value || undefined}
        onChange={(val) => onChange(val)}
        options={selectOptions}
        placeholder={placeholder || `Select ${label.toLowerCase()}`}
        style={{ minWidth: 180 }}
      />
    </div>
  );
}
